export default __webpack_public_path__ + "static/media/iou.04f530ec.jpg";